import * as Sentry from "@sentry/react";
import {
  IErrorMonitor,
  MonitoringLevel,
  MonitoringUser,
} from "../../domain/monitoring/IErrorMonitor";

export class SentryMonitor implements IErrorMonitor {
  constructor(dsn: string, environment: string, tracesSampleRate: number) {
    Sentry.init({
      dsn,
      environment,
      tracesSampleRate,
      integrations: [Sentry.browserTracingIntegration()],
      sendDefaultPii: true,
    });
  }

  captureException(error: unknown, context?: Record<string, unknown>): void {
    Sentry.withScope((scope) => {
      if (context) scope.setExtras(context);
      Sentry.captureException(error);
    });
  }

  captureMessage(message: string, level: MonitoringLevel = "info", extra?: Record<string, unknown>): void {
    Sentry.withScope((scope) => {
      if (extra) {
        scope.setExtras(extra);
      }
      scope.setLevel(level);
      Sentry.captureMessage(message);
    });
  }

  setUser(user: MonitoringUser): void {
    Sentry.setUser(user);
  }

  clearUser(): void {
    Sentry.setUser(null);
  }
}
